import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import fnolTheme from '@fnol/library/src/themes/fnolTheme';
import PpiApp from './components/PpiApp';

function App() {
    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={fnolTheme}>
                <PpiApp />
            </ThemeProvider>
        </>
    );
}

export default App;
